<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" selector :view-config="auth('b_customer_address_viewmanage')">
                <template #search>
                    <m-search ref="search" :default-data="defaultSearchData">
                        <m-search-item label="客户">
                            <c-select name="customer_id" async @search="searchCustomer" :value-data="selectedCustomer" clearable></c-select>
                        </m-search-item>
                        <m-search-item label="地址详情">
                            <c-input name="address_detail"></c-input>
                        </m-search-item>
                        <m-search-item label="备注">
                            <c-input name="remark"></c-input>
                        </m-search-item>
                        <m-search-item label="启用状态">
                            <c-checkbox-group name="enable_status" :options="disableEnableDic"></c-checkbox-group>
                        </m-search-item>
                    </m-search>
                </template>

                <!--启禁用状态-->
                <template #enable_status="{data}">
                    <c-switch v-if="auth('b_customer_address_edit')" v-model="data.enable_status" :state-value="[1, 2]" :state-text="['启用','禁用']" @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
                    <c-state v-else dict="disableEnableDic" :value="data.enable_status"></c-state>
                </template>

                <template #operate>
                    <c-button color="main" v-if="auth('b_customer_address_edit')" prepend-icon="tf-add" @click="$refs.editRef.open()">新增地址</c-button>
<!--                    <c-button v-if="auth('b_customer_address_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">按视图导出</c-button>-->
                </template>
                
<!--                <template #batchOperate="{data}">-->
<!--                    <c-button v-if="auth('b_customer_address_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">按视图导出</c-button>-->
<!--                </template>-->

                <template #otherOperate>
                    <c-button prepend-icon="tf-operate-record" v-if="auth('b_customer_address_log')" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
                </template>
                
                <c-table-column type="button" label="操作" width="180" button-limit="3">
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_customer_address_view')" icon="tf-view" @click="globalDialog('customerAddressDetail', {props: {id: data.id}})">查看</c-table-button>
                        <c-table-button v-if="auth('b_customer_address_edit')" icon="tf-edit" @click="$refs.editRef.open(data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_customer_address_edit')" icon="tf-delete" @click="removeAddress(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
            <customer-address-edit ref="editRef" @resolve="$refs.view.$refs.list.update()"></customer-address-edit>
        </module>
    </page>
</template>

<script>
import CustomerAddressEdit from "@/pages/basic/customer_address_edit.vue";
import { mapState } from 'vuex';

export default {
    components: {
        CustomerAddressEdit,
    },
    computed: {
        ...mapState(['disableEnableDic'])
    },
    data() {
        return {
            workType: 15,
            defaultSearchData: {},
            selectedCustomer: []
        }
    },
    methods: {
        searchCustomer(keyword, resolve) {
            this.request({
                url: '/system/options',
                data: { options_code: 'CUSTOMER', keyword: keyword },
                success: data => resolve(data)
            });
        },
        removeAddress(data) {
            this.$confirm({
                message: '确认删除该常用地址？删除后不可恢复',
                buttonName: '确定',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: '/customer/address/delete',
                        data: { id: data.id },
                        loading: true,
                        success: () => {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.$refs.view.$refs.list.update();
                        }
                    });
                },
                cancel: () => {},
            });
        },

        /******启禁用*********/
        stateHandle(state, next, data) {
            this.request({
                url: '/customer/address/update_status',
                data: {
                    id: data.id,
                    status: state ? 2 : 1
                },
                success: (data, message) => {
                    this.$message({
                        message: message,  // 提示内容,
                        type: 'success'
                    });
                    next();
                }
            })
        }
    },
}
</script>

<style lang="stylus" scoped>
</style>
